import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Check, X } from 'lucide-react';
import PurchaseInvoiceForm, { emptyComprobante } from '../PurchaseInvoiceForm';

export function ReviewReceptionDialog({ open, onOpenChange, reception, reviewNotes, setReviewNotes, onReview, onCancel }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Revisar Recepción Condicionada</DialogTitle>
          <DialogDescription>{reception?.reception_number}</DialogDescription>
        </DialogHeader>

        {reception && (
          <div className="space-y-4">
            <div className="bg-amber-50 p-3 rounded-lg">
              <p className="text-sm font-medium text-amber-800">Motivo del desvío:</p>
              <p className="text-sm">{reception.deviation_notes}</p>
            </div>

            <div>
              <Label>Notas de la revisión</Label>
              <Textarea
                value={reviewNotes}
                onChange={(e) => setReviewNotes(e.target.value)}
                rows={3}
                placeholder="Agrega comentarios sobre la decisión..."
              />
            </div>

            <DialogFooter className="gap-2">
              <Button variant="outline" onClick={onCancel}>Cancelar</Button>
              <Button variant="destructive" onClick={() => onReview('reject')}>
                <X className="w-4 h-4 mr-2" /> Rechazar
              </Button>
              <Button className="bg-green-600 hover:bg-green-700" onClick={() => onReview('approve')}>
                <Check className="w-4 h-4 mr-2" /> Aprobar
              </Button>
            </DialogFooter>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export function AddFiscalInvoiceDialog({ target, onClose, value, setValue, suppliers, accounts, expenseConcepts, withholdingTypes, adding, onSubmit }) {
  return (
    <Dialog open={!!target} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="add-fc-to-reception-dialog">
        <DialogHeader>
          <DialogTitle>Agregar comprobante fiscal a Recepción {target?.reception_number}</DialogTitle>
          <DialogDescription>
            Sumá otra FC del proveedor a esta recepción. Se registra automáticamente en el Libro IVA Compras, en la cuenta corriente del proveedor y en el Libro Diario (asiento contable).
          </DialogDescription>
        </DialogHeader>
        <PurchaseInvoiceForm
          value={value}
          onChange={setValue}
          suppliers={suppliers}
          accounts={accounts}
          expenseConcepts={expenseConcepts}
          withholdingTypes={withholdingTypes}
          imputationMode={false}
          showConcept={false}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={adding}>Cancelar</Button>
          <Button onClick={onSubmit} disabled={adding} data-testid="add-fc-submit">
            {adding ? 'Registrando…' : 'Registrar comprobante'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function DeleteFiscalInvoiceDialog({ deleteFC, onClose, deleting, onConfirm, reason, setReason }) {
  return (
    <Dialog open={!!deleteFC} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="delete-fc-dialog">
        <DialogHeader>
          <DialogTitle>Eliminar comprobante fiscal</DialogTitle>
          <DialogDescription>
            ¿Confirmás eliminar <b>{deleteFC?.fc?.tipo_comprobante} {deleteFC?.fc?.letra || ''} {deleteFC?.fc?.punto_venta}-{deleteFC?.fc?.numero}</b> por <b>${Number(deleteFC?.fc?.total || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}</b>?<br/>
            Se elimina el movimiento de cuenta corriente y el <b>asiento contable se reversa con un contra-asiento</b> con fecha de hoy: el asiento original queda visible en el Libro Diario marcado como reversado. Si el comprobante tiene pagos aplicados, se bloqueará la eliminación.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label>Motivo de la eliminación *</Label>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2}
            placeholder="Ej.: comprobante cargado por duplicado" data-testid="delete-fc-reason" />
          <p className="text-xs text-muted-foreground">Mínimo 10 caracteres. Queda registrado en el contra-asiento y en la auditoría.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={deleting}>Cancelar</Button>
          <Button variant="destructive" onClick={onConfirm} disabled={deleting || (reason || '').trim().length < 10} data-testid="delete-fc-confirm">
            {deleting ? 'Eliminando…' : 'Eliminar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { emptyComprobante };
